import { render, staticRenderFns } from "./AddDoc.vue?vue&type=template&id=b2b52a3a&"
import script from "./AddDoc.vue?vue&type=script&lang=js&"
export * from "./AddDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports